import { Formik } from 'formik';
import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormFeedback,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import ackAlarmsActions from '../../../../actions/ackAlarms.actions';
import phrasesActions from '../../../../actions/phrases.actions';
import { Checkbox, Dropdown, Input, Button, Alert } from '../../../UI/Common';
import validationSchema from './validation';
import helper from '../../../../utils/helper';
import ReactSelect from '../../../UI/ReactSelect';

const AckAlarm = (props) => {
  const requireAckAlarm = helper.getSetting('RequireAssignableCauses');
  const { t, phrases } = props;
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const form = {
    phraseId: undefined,
    ackInfo: '',
    keepInAlamList: false,
  };
  const [ackInfo, setAckInfo] = React.useState({
    ackInfo: '',
    keepInAlamList: false,
  });
  const [beError, setBeError] = React.useState('');
  React.useEffect(() => {
    if (props.isOpen) {
      if (props.sensorIds.length) {
        props.phrasesActions.getPhrases();
        props.ackAlarmsActions.getAckInfo(props.sensorIds).then((resp) => {
          if (resp.length) {
            if (resp.length === props.sensorIds.length) {
              const comparator = resp[0].ackInfo;
              let bulkable = true;
              resp.forEach((element) => {
                if (element.ackInfo !== comparator) {
                  bulkable = false;
                  return;
                }
              });
              if (bulkable) {
                setAckInfo({
                  ackInfo: resp[0].ackInfo,
                  keepInAlamList: resp[0].keepInAlamList,
                });
              } else {
                setError(
                  'Alarms do not have matching ack history and cannot be bulk acknowledged.',
                );
              }
            } else {
              setError(
                'Alarms do not have matching ack history and cannot be bulk acknowledged.',
              );
            }
          } else {
            setAckInfo({
              ackInfo: '',
              keepInAlamList: false,
            });
          }
        });
      }
    }
  }, [props.sensorIds, props.isOpen]);
  function onCreateAckAlarm(values, resetForm) {
    setLoading(true);
    setBeError('');
    props.ackAlarmsActions
      .createAckAlarm({
        ...values,
        phraseId: values.phraseId || 0,
        sensorIds: props.sensorIds,
      })
      .then(() => resetForm())
      .then(() => setLoading(false))
      .then(() => props.onAdd())
      .catch((err) => {
        setBeError(err);
        setLoading(false);
      });
  }
  React.useEffect(() => {
    if (!props.isOpen) {
      setTimeout(() => setError(null), 1000);
    }
  }, [props.isOpen]);
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...form, ...ackInfo }}
      validationSchema={validationSchema(
        requireAckAlarm.value.toLowerCase() === 'true',
      )}
      onSubmit={(values, { resetForm }) => onCreateAckAlarm(values, resetForm)}
    >
      {({
        values,
        handleChange,
        errors,
        setFieldTouched,
        setFieldValue,
        touched,
        handleSubmit,
        resetForm,
      }) => {
        return (
          <Modal isOpen={props.isOpen} className={props.className} fade={false}>
            <ModalHeader>
              <span style={{ verticalAlign: 'text-bottom' }}>
                {t('Add Alarm Acknowledgement')}: {props.sensorName}
              </span>
            </ModalHeader>
            <ModalBody>
              {error ? (
                error
              ) : (
                <Form style={{ marginBottom: 0 }}>
                  <ReactSelect
                    options={phrases.phrases}
                    label="Phrase"
                    value={values.phraseId}
                    onChange={({ value, label }) => {
                      setFieldValue('phraseId', value);
                      setFieldValue('ackInfo', `${label} : ${values.ackInfo}`);
                    }}
                    valueKey="id"
                    labelKey="phrase"
                    getOptionLabel={(obj) => (
                      <div>
                        <p style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                          {obj.phrase}
                        </p>
                        <p
                          style={{
                            marginTop: 0,
                            marginBottom: '0.5rem',
                            fontSize: '0.75rem',
                            fontStyle: 'italic',
                          }}
                        >
                          {obj.id}
                        </p>
                      </div>
                    )}
                    filterOption={(option, searchText) => {
                      if (
                        option.data.phrase
                          .toLowerCase()
                          .includes(searchText.toLowerCase()) ||
                        option.data.id
                          .toString()
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                      ) {
                        return true;
                      } else {
                        return false;
                      }
                    }}
                    invalid={touched.phraseId}
                    error={errors.phraseId}
                  />
                  <Input
                    required={
                      requireAckAlarm.value.toLowerCase() === 'true'
                        ? true
                        : false
                    }
                    type="textarea"
                    inputClass="custom-text-area"
                    label="Ack Detail Info"
                    id="ackInfo"
                    value={values.ackInfo}
                    onChange={handleChange('ackInfo')}
                    invalid={errors.ackInfo && touched.ackInfo}
                    error={errors.ackInfo}
                    accessory={
                      <FormFeedback
                        className="d-flex justify-content-end"
                        style={{
                          color: values.ackInfo.length > 2500 ? 'red' : 'black',
                        }}
                      >
                        {values.ackInfo.length}/2500 characters
                      </FormFeedback>
                    }
                  />
                  <Checkbox
                    id="keepInAlamList"
                    label="Keep In List"
                    checked={values.keepInAlamList}
                    onChange={(isCheck) =>
                      setFieldValue('keepInAlamList', isCheck)
                    }
                  />
                  <Alert.Error text={beError} />
                </Form>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  props.onCancel();
                  resetForm(form);
                }}
              >
                {t(error ? 'OK' : 'Cancel')}
              </Button>
              {!error && (
                <Button
                  color="primary"
                  onClick={handleSubmit}
                  loading={loading}
                >
                  {t('Add')}
                </Button>
              )}
            </ModalFooter>
          </Modal>
        );
      }}
    </Formik>
  );
};

function mapStateToProps(state) {
  return {
    ackAlarms: state.ackAlarms,
    phrases: state.phrases,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ackAlarmsActions: bindActionCreators(
      Object.assign({}, ackAlarmsActions),
      dispatch,
    ),
    phrasesActions: bindActionCreators(
      Object.assign({}, phrasesActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AckAlarm);
